var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('div',{staticClass:"d-block d-sm-block d-md-none"},[_c('SwipeUpCart'),_c('FooterMobile',{attrs:{"show_details":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }